import api from "./api";

export const getTaskStats = (params = {}) => {
  return api.get("/tasks/dashboard/stats", { params });
};
